let isDragging = false

export declare interface IOptions {
  drag?: (event: MouseEvent) => void
  start?: (event: MouseEvent) => void
  end?: (event: MouseEvent) => void
}

export default function (ele: HTMLElement, options: IOptions) {
  const moveFun = function (event: MouseEvent) {
    options?.drag?.(event)
  }

  const upFun = function (event: MouseEvent) {
    document.removeEventListener('mousemove', moveFun)
    document.removeEventListener('mouseup', upFun)
    document.onselectstart = null
    document.ondragstart = null

    isDragging = false

    options?.end?.(event)
  }

  ele.addEventListener('mousedown', function (event: MouseEvent) {
    if (isDragging) return
    document.onselectstart = () => false
    document.ondragstart = () => false
    document.addEventListener('mousemove', moveFun)
    document.addEventListener('mouseup', upFun)

    isDragging = true

    options?.start?.(event)
  })
}
